
import Component from "vue-class-component";
import Vue from "vue";
import {
    HarbourLightModel,
    SysAdminHarboursClient
} from "@/api-client";
import {BvTableFieldArray} from "bootstrap-vue";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
import Loader from "@/features/shared/components/Loader";
import {debounceFn} from "debounce-decorator-ts";

@Component({
    components: {
        TableEmptySlot,
        HeadingWave,
        SectionPageHeading
    },
})
export default class Harbours extends Vue {
    harbours: HarbourLightModel[] = [];

    loader = new Loader(true);

    searchPhrase = "";
    initialSort = {sortBy: "name", sortDesc: false};

    created() {
        this.getParametersFromRouteOrDefault();

        this.$watch(() => this.searchPhrase, () => {
            this.reflectParametersToRoute();
        });

        this.$watch(() => this.$route.query, () => {
            this.search();
        }, {deep: true, immediate: true});
    }

    @debounceFn(100) // Prevents possible double-update
    reflectParametersToRoute(): void {
        this.$router.replace({
            query: {
                // Setting to 'undefined' removes parameter from URL.
                searchPhrase: this.searchPhrase || undefined
            }
        });
    }

    getParametersFromRouteOrDefault() {
        const route = this.$route as any;
        const query = route.query;
        this.searchPhrase = query.searchPhrase ? query.searchPhrase : '';
    }

    async search() {
        this.harbours = [];
        this.harbours = await new SysAdminHarboursClient().setLoader(this.loader).all(this.searchPhrase);
    }

    editHarbour(update: HarbourLightModel) {
        this.$router.push({name: 'edit-harbour', params: {id: update.id!}});
    }

    fields: BvTableFieldArray = [
        {
            key: "name",
            label: this.$ls.Global_Label_Name,
            sortable: true,
            sortByFormatted: true,
            thClass: "w-50"
        },
        {
            key: "id",
            label: this.$ls.Global_Label_Id,
            sortable: false
        },
        {
            key: "isActive",
            label: this.$ls.Global_Label_Active,
            sortable: true,
            sortByFormatted: true,
            formatter: (value: any, key: any, item: HarbourLightModel): string => translateTrueFalse(item.isActive)
        },
        {
            key: "linkIcon",
            label: "",
            sortable: false,
            tdClass: "table-actions"
        },
    ];
}
